/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataSourceConfig } from '../models/DataSourceConfig';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DataSourceControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns DataSourceConfig OK
     * @throws ApiError
     */
    public getDataSources(): CancelablePromise<Array<DataSourceConfig>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data-sources',
        });
    }
}
